import { createBrowserRouter, Navigate } from 'react-router-dom';
import ContactPage from '../domains/contact/Page';
import CoursesPage from '../domains/courses/components/course/CoursesPage';
import HistoryDialog from '../domains/courses/components/prono/detail/HistoryDialog';
import PronoPage from '../domains/courses/components/prono/PronoPage';
import StatsDialog from '../domains/courses/components/prono/StatsDialog';
import HomePage from '../domains/home/HomePage';
import { getCurrentDate } from "../utils/format";
import CoursesLayout from './CoursesLayout';
import ErrorPage from './ErrorPage';
import Layout from './Layout';
import PronoLayout from './PonoLayout';
import TipsLayout from './TipsLayout';
import TipsIndexPage from '../domains/tips/IndexPage';
import TipArticlePage from '../domains/tips/ArticlePage';
import LexiquePage from '../domains/tips/LexiquePage';

export enum ROUTES {
  HOME = '/',
  CONTACT = 'contact',
  COURSES = 'courses/:date',
  PRONOS = 'pronos/:r/:c',
  STATS = 'stats',
  HISTORY = 'history/:num',
  LOGIN = 'login',
  CREATE_LOGIN = 'create-login',
  PARAMS = 'parameters',
  TIPS = 'tips',
  TIPS_PARIS = 'paris-hippiques/:slug',
  TIPS_METHODE = 'methode/:slug',
  TIPS_LEXIQUE = 'lexique',
  TIPS_STRATEGIE = 'strategie/:slug',
}

export const router = createBrowserRouter([
  {
    path: ROUTES.HOME,
    element: <HomePage />,
    errorElement: <ErrorPage />,
  },
  {
    element: <Layout />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: ROUTES.CONTACT,
        element: <ContactPage />,
      },
      {
        path: ROUTES.TIPS,
        element: <TipsLayout />,
        children: [
          {
            index: true,
            element: <TipsIndexPage />,
          },
          {
            path: ROUTES.TIPS_PARIS,
            element: <TipArticlePage category="paris-hippiques" />,
          },
          {
            path: ROUTES.TIPS_METHODE,
            element: <TipArticlePage category="methode" />,
          },
          {
            path: ROUTES.TIPS_LEXIQUE,
            element: <LexiquePage />,
          },
          {
            path: ROUTES.TIPS_STRATEGIE,
            element: <TipArticlePage category="strategie" />,
          },
        ],
      },

      // ✅ Redirection si pas de date
      {
        path: "courses",
        element: (
          <Navigate
            to={`/courses/${getCurrentDate()}`}
            replace
          />
        ),
      },

      // ✅ Route avec date obligatoire
      {
        path: ROUTES.COURSES, // "courses/:date"
        element: <CoursesLayout />,
        children: [
          {
            index: true,
            element: <CoursesPage />,
          },
          {
            path: ROUTES.PRONOS, // "pronos/:r/:c"
            element: <PronoLayout />,
            children: [
              {
                index: true,
                element: <PronoPage />,
              },
              {
                path: ROUTES.STATS,
                element: <StatsDialog />,
              },
              {
                path: ROUTES.HISTORY,
                element: <HistoryDialog />,
              },
            ],
          },
        ],
      },
    ],
  },
]);



export default router;
